
import React from 'react';
import {connect} from "react-redux";
import {DashboardContainer} from "../../funcs/utils";
import {sprintf} from "sprintf-js";
import {date_to_time_str} from "../../../lib/time";
import {DashboardTable} from "../dashboard-table";
import {dollarToString} from "../../../lib/currency-utils";
import {USER} from "../../../lib/constants";

const COLUMN_HEADERS = [
  "Timestamp", "Status", "Amt", "CUSIP", "Coupon",
  "Maturity", "Issuer", "Price", "Settle Date",
  "Bond Information"
];

const EST_TIMEZONE = "America/New_York";

const dump_timestamp = time_sec => {

  const local_date = new Date(time_sec * 1000);
  // convert to EST timezone
  const est_date = new Date(local_date.toLocaleString('en-US', {
    timeZone: EST_TIMEZONE,
  }));

  return sprintf("%02d-%02d-%04d %s EST",
    est_date.getMonth() + 1, est_date.getDate(),
    est_date.getFullYear(), date_to_time_str(est_date));
}

const get_today_date = () => {
  const today = new Date();
  return sprintf("%04d-%02d-%02d", today.getFullYear(), today.getMonth() + 1, today.getDate());
}

const parse_settle_date = settle_date => {
  const [ mm, dd, yyyy ] = settle_date.split("/");
  return sprintf("%s-%02d-%02d", yyyy, parseInt(mm, 10), parseInt(dd, 10));
}

class SecurityPurchasesCard_ extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  dumpTable = () => {
    const purchase_items = this.props.items;
    const debug = this.props.debug;
    const selected_row = -1;
    const table_items = [ [ ...COLUMN_HEADERS] ];
    const is_admin = this.props.user.account_type !== USER;
    const today_date = get_today_date();
    if (debug) {
      table_items[0].unshift("Ticket ID");
    }

    for(let i=0; i < purchase_items.length; i++) {
      const item = purchase_items[i];
      const cusip = item.metadata.cusip_metadata;
      const is_canceled = item.metadata.state === "CANCELED";
      const settle_date_str = parse_settle_date(cusip['Settle Date']);
      if (!is_admin && is_canceled && today_date >= settle_date_str) {
        continue;
      }
      const line = [];
      if (debug) {
        line.push(item.id);
      }
      line.push(dump_timestamp(item.requested));
      line.push(item.metadata.state);
      line.push(dollarToString(item.metadata.amt_usd));
      line.push(cusip.CUSIP);
      line.push(sprintf("%.2f", cusip.Coupon));
      line.push(cusip.Maturity);
      line.push(cusip.Issue || cusip.Issuer);
      line.push(cusip.Price);
      line.push(cusip['Settle Date']);
      line.push(cusip['Bond Information']);

      table_items.push(line);
    }

    const style_lut = [
      {
        pred: (row, col) => row % 2 === 0,
        style: {
          background: "#EEE",
        }
      },
      {
        pred: (row, col) =>
          row - 1 === selected_row && selected_row !== -1,
        style: {
          background: "#DDD",
        }
      },
      {
        pred: (row, col) => row === 0,
        style: {
          background: "#CCC",
        }
      },
      {
        pred: (row, col) => true,
        style: {
          padding: "0 0.5rem",
          border: "solid black 1px",
        }
      }
    ];

    const container_style = {
      overflowX: "auto",
    }
    return (
      <div style={container_style}>
        <DashboardTable
          tdStyleLut={style_lut}
          data={table_items}/>
      </div>
    );
  }

  render = () => {
    const text = "Pending status is not a guaranteed fill.";

    return (
      <DashboardContainer
        div_style={{ marginTop: "0"}}
        title={this.props.title}
        client={this.props.client}>
        { this.dumpTable() }
        <div>
          <div style={{height: "2rem"}}/>
          { text }
        </div>
      </DashboardContainer>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

const mapStateToProps = state => {
  return {
    client: state.client,
    user: state.user,
  }
}

const SecurityPurchasesCard = connect(mapStateToProps, mapDispatchToProps)(SecurityPurchasesCard_);

export { SecurityPurchasesCard } ;
